import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "components/ui/data-table-column-header";
import { titleCase } from "lib/utils";
import { CtoLhcSummary } from "./api/reports";

export const createSimConsentReportsColumns = (): ColumnDef<CtoLhcSummary>[] => [
  {
    accessorKey: "lhc_branch",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Branch Name" />
    ),
    cell: ({ row }) => {
      const value = row.getValue("lhc_branch") as string;
      return (
        <div className="max-w-[150px] truncate text-xs" title={value}>
          {titleCase(value)}
        </div>
      );
    },
    enableSorting: true,
  },
  {
    accessorKey: "total_lhcs",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Total Line LHCs" />
    ),
    cell: ({ row }) => <div className="text-xs">{row.getValue("total_lhcs")}</div>,
    enableSorting: true,
  },
  {
    accessorKey: "allowed_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consent Taken" />
    ),
    cell: ({ row }) => <div className="text-xs">{row.getValue("allowed_count")}</div>,
    enableSorting: true,
  },
  {
    accessorKey: "null_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consent Not Taken" />
    ),
    cell: ({ row }) => <div className="text-xs">{row.getValue("null_count")}</div>,
    enableSorting: true,
  },
  {
    accessorKey: "allowed_pct",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consent Taken %" />
    ),
    cell: ({ row }) => {
      const pct = row.getValue("allowed_pct") as number;
      const colorClass =
        pct >= 50 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600";
      return (
        <div
          className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs `}
        >
          {pct?.toFixed(2)}%
        </div>
      );
    },
    enableSorting: true,
  },
];
